export default "__VITE_ASSET__6de769e0__"